import { BehaviorSubject } from "rxjs";

const directionSubject = new BehaviorSubject();

export const directionService = {
  sendDirectionChange: () => directionSubject.next(),
  getDirectionChange: () => directionSubject.asObservable(),
};
